module.exports = "/packs/course-small-project-management-16fac821e31b3c57de65edb5500d72f3.png";